import React from 'react';
import { TextField } from '@mui/material';
import { DatePickerProps } from './interface';
import moment from 'moment';

const DatePicker = (props: DatePickerProps) => {
  const { onChange, value, label, ...otherProps } = props;
  
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const dateValue = event.target.value;
    if (dateValue) {
      onChange(moment(dateValue));
    } else {
      onChange(null);
    }
  };

  return (
    <TextField
      label={label}
      type="date"
      value={value ? moment(value).format('YYYY-MM-DD') : ''}
      onChange={handleChange}
      InputLabelProps={{ shrink: true }}
      {...otherProps}
    />
  );
};

export default DatePicker;
